import { Box, Grid as ChakraGrid, Link, Text } from '@chakra-ui/react';
import { TextLink } from '@time-line/components/common';
import { useImage } from 'lib/sanity';
import Image from 'next/image';
import NextLink from 'next/link';
import type { SanityProduct } from 'types/cms/SanityProduct';

export interface InfoProps {
  product: SanityProduct;
  isLight?: boolean;
}

export const ReviewedProductInfo = ({ product, isLight }: InfoProps) => {
  const productThumbnail = product.images[0];
  const { title, href } = product;

  const imageProps = useImage(productThumbnail || null, { ratio: 1 });

  if (!title || !productThumbnail) return null;

  return (
    <ChakraGrid gap="2xs" gridTemplateColumns="auto 1fr">
      {productThumbnail && imageProps && (
        <Link as={NextLink} href={href}>
          <Image
            {...imageProps}
            height="40"
            width="40"
            alt={title}
            className="round"
          />
        </Link>
      )}
      <Box>
        <Text size="detail" color={isLight ? 'gray.50' : 'blackAlpha.700'}>
          Reviewed
        </Text>
        <TextLink
          as={NextLink}
          href={href}
          noOfLines={1}
          textProps={{ size: 'detail' }}
          variant="underline"
          color={isLight ? 'gray.50' : 'gray.600'}
        >
          <Text size="detail" noOfLines={1}>
            {title}
          </Text>
        </TextLink>
      </Box>
    </ChakraGrid>
  );
};
